import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import { additionalPageContentApi } from "@helsenorge/framework-utils/additional-page-content";
import oppgaveListeReducer from "./slices/slice-oppgaveListe";
import oppgaveDetaljerReducer from "./slices/slice-oppgaveDetaljer";
import { createLanguageReducer } from "@helsenorge/framework-utils/language";
import LanguageLocales from "@helsenorge/core-utils/constants/languages";
import { tjenesteTeksterApi } from "@helsenorge/framework-utils/cms-tjeneste-tekster";
import prosesshjelp from "@helsenorge/core-framework/prosesshjelp/store";
import { resourcesApi } from "resources";

const rootReducer = combineReducers({
  oppgaveListe: oppgaveListeReducer,
  oppgaveDetaljer: oppgaveDetaljerReducer,
  resourcesApi,
  prosesshjelp,
  language: createLanguageReducer([
    LanguageLocales.NORWEGIAN,
    LanguageLocales.NORWEGIAN_NYNORSK,
    LanguageLocales.ENGLISH,
  ]),
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(tjenesteTeksterApi.middleware)
      .concat(resourcesApi.middleware)
      .concat(additionalPageContentApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

export default rootReducer;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
